import { ACCOUNT_DASHBOARD, MY_HOMEPAGE, WORKSPACE_DASHBOARD } from './constants';

/**
 * Read from the page listener's `pageInfo`, since a slot component can't know which page hosts it.
 * Reported verbatim, `maml:` prefix and all; homepage when nothing has written it.
 */
export const getPageType = () => digitalData?.page?.pageInfo?.pageType || MY_HOMEPAGE;

// Classic and Fusion B2B account dashboards; every other page keeps the workspace dashboard values.
export const isAccountDashboard = () => getPageType() === `maml:${ACCOUNT_DASHBOARD}`;

export const getWidgetTemplates = () => (isAccountDashboard() ? ACCOUNT_DASHBOARD : WORKSPACE_DASHBOARD);

export const getSettingsPrefix = () => (
  isAccountDashboard() ? ACCOUNT_DASHBOARD : `${MY_HOMEPAGE}: ${WORKSPACE_DASHBOARD}`
);
